import axios from "axios";

// Prefer the current browser origin at runtime (works for any custom domain
// mapped after build). Falls back to REACT_APP_BACKEND_URL for non-browser
// contexts (SSR, tests). This keeps auth cookies same-origin regardless of
// which domain the app is served from.
const BACKEND_URL =
  typeof window !== "undefined" && window.location && window.location.origin
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// Attach Bearer token as a fallback for third-party cookie blockers.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("helvar_access_token");
  if (token) config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
